import { Injectable, ElementRef } from '@angular/core';
import { PgSubscriptMessagesComponent } from './pg-subscript-messages.component';

@Injectable({
  providedIn: 'root',
})
export class PgSubscriptStateCalculator {
  public calculateSubscriptState(
    messagesHost: PgSubscriptMessagesComponent
  ): {
    isVisible: boolean;
    elementRef: ElementRef;
  }[] {
    const temp = [];
    const hintChild = messagesHost.hintChild;
    const errorChildren = messagesHost.errorChildren;
    const displayMode = messagesHost.getSubscriptMessageType();
    let displayableMessageChosen = false;
    if (hintChild) {
      displayableMessageChosen = displayMode === 'hint';
      temp.push({
        isVisible: displayableMessageChosen,
        elementRef: hintChild.elementRef,
      });
    }

    errorChildren.forEach(ec => {
      const show =
        displayMode === 'error' &&
        !displayableMessageChosen &&
        messagesHost.control.ngControl.hasError(ec.for);
      temp.push({
        isVisible: show,
        elementRef: ec.elementRef,
      });
      if (show) {
        displayableMessageChosen = true;
      }
    });
    return temp;
  }
}
